export const PURCHASE_DEBIT_NOTE_TYPES = [
    { value: 'rate_difference', label: 'Rate Difference' },
    { value: 'additional_charges', label: 'Additional Charges' },
    { value: 'others', label: 'Others' },
];

export { PURCHASE_NOTE_VOUCHER_MODES } from './PurchaseCreditNoteUtils';
export { recalculatePurchaseNoteLine } from './PurchaseCreditNoteUtils';

export function getPurchaseDebitNoteTypeLabel(dnType) {
    return PURCHASE_DEBIT_NOTE_TYPES.find((item) => item.value === dnType)?.label || dnType || '';
}

export function buildPurchaseDebitNoteTotals(productLines = [], documentLines = []) {
    const totals = productLines.reduce((acc, line) => {
        acc.taxable_amt += parseFloat(line.taxable_amt) || 0;
        acc.cgst_amt += parseFloat(line.cgst_amt) || 0;
        acc.sgst_amt += parseFloat(line.sgst_amt) || 0;
        acc.igst_amt += parseFloat(line.igst_amt) || 0;
        acc.gst_amt += parseFloat(line.gst_amt) || 0;
        acc.gross_amt += parseFloat(line.gross_amt) || 0;
        return acc;
    }, {
        taxable_amt: 0,
        cgst_amt: 0,
        sgst_amt: 0,
        igst_amt: 0,
        gst_amt: 0,
        gross_amt: 0,
        debit_amt: 0,
        round_off: 0,
    });
    totals.debit_amt = documentLines.reduce(
        (sum, line) => sum + (parseFloat(line.debit_amt) || 0),
        0,
    );
    totals.taxable_amt = Math.round(totals.taxable_amt * 100) / 100;
    totals.cgst_amt = Math.round(totals.cgst_amt * 100) / 100;
    totals.sgst_amt = Math.round(totals.sgst_amt * 100) / 100;
    totals.igst_amt = Math.round(totals.igst_amt * 100) / 100;
    totals.gst_amt = Math.round(totals.gst_amt * 100) / 100;
    totals.gross_amt = Math.round(totals.gross_amt * 100) / 100;
    totals.debit_amt = Math.round(totals.debit_amt * 100) / 100;
    const decimal = totals.debit_amt - Math.floor(totals.debit_amt);
    totals.round_off = decimal >= 0.5
        ? Math.round((1 - decimal) * 100) / 100
        : Math.round(-decimal * 100) / 100;
    totals.debit_amt = Math.round((totals.debit_amt + totals.round_off) * 100) / 100;
    return totals;
}

export function syncDocumentDebitAmounts(productLines = [], documentLines = []) {
    const gross = Math.round(
        productLines.reduce((sum, line) => sum + (parseFloat(line.gross_amt) || 0), 0) * 100,
    ) / 100;
    if (!documentLines.length) {
        return documentLines;
    }
    let remaining = gross;
    return documentLines.map((line) => {
        const debitAmt = Math.max(remaining, 0);
        remaining = Math.round((remaining - debitAmt) * 100) / 100;
        return { ...line, debit_amt: Math.round(debitAmt * 100) / 100 };
    });
}

export function applyPurchaseDebitNoteTypeToLines(dnType, productLines = [], documentLines = []) {
    let nextProductLines = productLines;
    if (dnType === 'others' && productLines.length === 0) {
        nextProductLines = [{
            sl_no: 1,
            description: '',
            unit: '',
            qty: 0,
            basic_rate: 0,
            taxable_amt: 0,
            tax_id: '',
            cgst_per: 0,
            sgst_per: 0,
            igst_per: 0,
            cgst_amt: 0,
            sgst_amt: 0,
            igst_amt: 0,
            gst_amt: 0,
            gross_amt: 0,
        }];
    }
    return {
        productLines: nextProductLines,
        documentLines: syncDocumentDebitAmounts(nextProductLines, documentLines),
    };
}
